import React, { useState, useEffect, useRef } from 'react';

import { createPortal } from 'react-dom';

import classNames from 'classnames';

import classes from './styles.module.scss';

const positions = {
  'top-left': classes.topLeft,
  'top-right': classes.topRight,
  bottom: classes.bottom,
  left: classes.left,
};

export default function Tooltip({
  children,
  show = true,
  text,
  width,
  position,
  textAlign,
  backgroundColor,
}) {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isFixedTooltipVisible, setIsFixedTooltipVisible] = useState(false);

  const tooltipRef = useRef();
  const containerRef = useRef();

  useEffect(() => {
    if (!show) {
      setIsTooltipVisible(false);
    }
  }, [show, isTooltipVisible]);

  useEffect(() => {
    if (isTooltipVisible) {
      const coords = tooltipRef.current?.getBoundingClientRect?.();

      document.body.style.setProperty('--tooltip-top', `${coords?.top}px`);
      document.body.style.setProperty('--tooltip-left', `${coords?.left}px`);
      document.body.style.setProperty('--tooltip-width', `${coords?.width}px`);
      setIsFixedTooltipVisible(true);
    } else {
      setIsFixedTooltipVisible(false);
    }
  }, [isTooltipVisible]);

  return (
    <div
      ref={containerRef}
      className={classNames(classes.Tooltip, positions[position])}
      onMouseEnter={() => {
        setIsTooltipVisible(true);
      }}
      onMouseLeave={() => {
        setIsTooltipVisible(false);
      }}
    >
      {children}
      {(isTooltipVisible || true) && (
        <div
          className={classes.hiddenTooltip}
          ref={tooltipRef}
          style={{ width, textAlign }}
        >
          {text}
        </div>
      )}
      {isFixedTooltipVisible &&
        createPortal(
          <div
            className={classNames(classes.visibleTooltip, positions[position])}
            style={{ width, textAlign, position: 'fixed', backgroundColor }}
          >
            {text}
          </div>,
          document.body
        )}
    </div>
  );
}
